<ng-container *ngIf="{isInitialShowModal: isInitialShowModal$ | async, showOrderTypeModal: showOrderTypeModal$ | async} as data">
  <app-modal
    *ngIf="isShowModal"
    (closeModal)="onClose()"
    title="Select order receipt type"
    i18n-title="@@SelectOrderTypeTitle"
  >
    <div class="delivery-type-form" *ngIf="settings$ | async as settings">
      <div class="delivery-type-form__head" *ngIf="settings.isProvidingCollection && settings.isProvidingDelivery">
        <app-switcher
          [formControl]="switchControl"
          [values]="[deliveryTypes.Delivery, deliveryTypes.Pickup]"
          (changeValue)="onChangeOrderType($event)"
        >
          <span class="h4 switcher-btn" i18n="@@Delivery" leftTitle>Delivery</span>
          <span class="h4 switcher-btn" i18n="@@DeliveryByClient" rightTitle>Pickup</span>
        </app-switcher>
      </div>
      <div class="delivery-type-form__body"
           *ngIf="{selectedDeliveryType: selectedDeliveryType$ | async, deliveryAddress: deliveryAddress$ | async} as data"
      >
        <app-address-selector [formControl]="addressControl" *ngIf="data.selectedDeliveryType"></app-address-selector>
      </div>
    </div>
  </app-modal>
</ng-container>

